var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-box"},[_c('v-btn',{staticClass:"data-btn",attrs:{"color":"warning"},on:{"click":function($event){return _vm.editData()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-plus ")]),_vm._v(" 新增列表 ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }